export var FEEDBACK_DIV_ID = 'harmony-inapp-feedback-element-id';
export var HARMONY_APP_ID = 2131;
export var HARMONY_APP_NAME = 'Harmony';
// This must match with a value expected from the HVC
export var OCV_IN_APP_FEEDBACK_FEATURE = 'ocv-inapp-feedback';
//# sourceMappingURL=constants.js.map